import React from "react";
import { Grid, Typography } from "@material-ui/core";
import { Skeleton } from '@material-ui/lab';


export default function DetailLabel({
  label,
  text,
  containerStyle,
  labelStyle,
  textStyle,
  loading
}) {
  return (
    <Grid item xs={4} sm={2}>
      {
        loading ? (
          <Skeleton variant="text">
            <Typography variant="body2" style={{ color: "grey", fontWeight: 300 }}>
              {label}
            </Typography>
          </Skeleton>
        ) : (
          <Typography variant="body2" style={{ color: "grey", fontWeight: 300, fontFamily: "Arvo" }}>
            {label}
          </Typography>          
        )
      }
      {
        loading ? (
          <Skeleton variant="text">
            <Typography variant="body2" style={{ fontWeight: 400 }}>
              {text}
            </Typography>          
          </Skeleton>
        ) : (
          <Typography variant="body2" style={{ fontWeight: 400, fontFamily: "Lato" }}>
            {text}
          </Typography>          
        )
      }
    </Grid>
  );
}
